import { array, dateTime, defineAction, enumerated, number, object, string } from '~/prix'
import entrepreneurAgentRequestDetailAction from './entrepreneurAgentRequestDetail.action.json' with { type: 'json' }

const requestState = () =>
  enumerated({
    searchingAgents: 'searching_agents',
    agentAccepted: 'agent_accepted',
    agentArrived: 'agent_arrived',
    inAttendance: 'in_attendance',
    allAgentsRefused: 'all_agents_refused',
    noAgentsAvailable: 'no_agents_available',
    done: 'done',
    canceled: 'canceled',
    unknown: 'unknown',
  })

const requestActor = () =>
  enumerated({
    entrepreneur: 'entrepreneur',
    agent: 'agent',
    system: 'system',
  })

const entrepreneurAgentRequestDetailDefinition = defineAction({
  ...entrepreneurAgentRequestDetailAction,
  userActivityLog: true,
  operation: 'read' as const,
  input: object({
    requestId: string(),
  }),
  output: object({
    state: requestState(),
    address: object({
      display: string().isOptional(),
      postalCode: string().isOptional(),
      stateAbbreviation: string().isOptional(),
      city: string().isOptional(),
      cityId: number().isOptional(),
      neighborhood: string().isOptional(),
      street: string().isOptional(),
      number: string().isOptional(),
      complement: string().isOptional(),
      reference: string().isOptional(),
    }),
    companyName: string().isOptional(),
    serviceReason: string().isOptional(),
    acceptedAgent: object({
      cpf: string(),
    }).isOptional(),
    route: object({
      status: enumerated({
        calculated: 'calculated',
        unavailable: 'unavailable',
      }).isOptional(),
      distanceMeters: number().isOptional(),
      durationSeconds: number().isOptional(),
      geometry: object({
        type: enumerated({
          lineString: 'LineString',
        }),
        coordinates: array(array(number())),
      }).isOptional(),
      calculatedAt: dateTime().isOptional(),
      agentLocationCapturedAt: dateTime().isOptional(),
      estimatedArrivalAt: dateTime().isOptional(),
    }),
    timestamps: object({
      createdAt: dateTime(),
      acceptedAt: dateTime().isOptional(),
      arrivedAt: dateTime().isOptional(),
      attendanceStartedAt: dateTime().isOptional(),
      closedAt: dateTime().isOptional(),
      updatedAt: dateTime(),
    }),
    cancellation: object({
      canceledBy: requestActor().isOptional(),
      reasonCode: string().isOptional(),
      reasonDetail: string().isOptional(),
    }),
    timeline: array(
      object({
        type: enumerated({
          requestCreated: 'request_created',
          agentOffered: 'agent_offered',
          agentAccepted: 'agent_accepted',
          agentRefused: 'agent_refused',
          agentArrived: 'agent_arrived',
          attendanceStarted: 'attendance_started',
          requestCompleted: 'request_completed',
          requestCanceled: 'request_canceled',
          requestClosed: 'request_closed',
        }),
        occurredAt: dateTime(),
        actor: requestActor().isOptional(),
      }),
    ),
  }),
})

export default entrepreneurAgentRequestDetailDefinition
